import { Box, Flex, StatusIndicator, Text } from "@nulogy/components";
import Field from "components/common/Field";
import UnstyledLink from "components/common/UnstyledLink";
import { formatDate, formatDayOfWeek, formatDuration, formatTime } from "components/helpers/format";
import Block from "domain/Block";
import map from "lodash/map";
import React from "react";

const WorkBlockDetails = ({ workBlock, onNavigateToWorkBlock }) => (
  <Box>
    <UnstyledLink
      className={`spec-work-block-link-${workBlock.id}`}
      data-testid="work-block-item"
      key={`scheduled-block-${workBlock.id}`}
      onClick={() => onNavigateToWorkBlock(workBlock)}
      style={{ fontWeight: "normal" }}
    >
      {formatWorkBlock(workBlock)}
    </UnstyledLink>
    <Box pb="x1">
      {workBlock.overlappingPlannedBreaks.length > 0 &&
        workBlock.overlappingPlannedBreaks.map((plannedBreak) => (
          <Text key={plannedBreak.plannedBreakName}>
            {`Includes ${plannedBreak.plannedBreakName}`} (<strong>{formatDuration(plannedBreak.duration)}</strong>)
          </Text>
        ))}
      <TeardownTimeDuration workBlock={workBlock} />
    </Box>
  </Box>
);

function formatWorkBlock(workBlock) {
  const dayOfWeek = formatDayOfWeek(workBlock.startsAt);
  const date = formatDate(workBlock.startsAt);
  const time = formatTime(workBlock.startsAt);
  const duration = formatDuration(Block.blockTime(workBlock).durationInSeconds());

  return (
    <>
      {dayOfWeek} {date} • {time} (<strong>{duration}</strong>)
    </>
  );
}

const TeardownTimeDuration = ({ workBlock }) =>
  workBlock.teardownTimeDuration > 0 && (
    <Text data-testid="teardown-time-duration">
      Includes {workBlock.teardownTimeLabel} (<strong>{formatDuration(workBlock.teardownTimeDuration)}</strong>)
    </Text>
  );

export default function ScheduledWorkBlockDetailsView({
  onNavigateToWorkBlock,
  scheduledDuration,
  linesWithWorkBlocks,
}) {
  return (
    <>
      {scheduledDuration > 0 ? (
        <>
          <Field data-testid="scheduled-duration" labelText="Total scheduled duration">
            {formatDuration(scheduledDuration)}
          </Field>
          <Flex flexDirection="column" gap="half">
            {map(linesWithWorkBlocks, (lineWithWorkBlocks) => {
              const { id, name, workBlocks, active } = lineWithWorkBlocks;

              const lineText = (
                <Flex className="spec-scheduled-work-block-line-name">
                  {name}
                  {!active && <StatusIndicator ml="half">Inactive</StatusIndicator>}
                </Flex>
              );

              return (
                <Box data-testid="line-group" key={`line-${id}`}>
                  <Field labelText={lineText} mb="0">
                    {map(workBlocks, (workBlock) => (
                      <WorkBlockDetails
                        key={`container-scheduled-block-${workBlock.id}`}
                        onNavigateToWorkBlock={onNavigateToWorkBlock}
                        workBlock={workBlock}
                      />
                    ))}
                  </Field>
                </Box>
              );
            })}
          </Flex>
        </>
      ) : (
        <Text data-testid="no-schedule-blocks-message" fontStyle="italic">
          No blocks scheduled
        </Text>
      )}
    </>
  );
}
